export default "__VITE_ASSET__DtCpphqs__"